import { Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { SingleCause } from "../Causes/SingleCause";
import { SingleEvaluation } from "./SingleEvaluation";

// Evaluacion solo para la vista
export const EvaluationsView = ({
  evaluations,
  causes,
  justView,
}) => {

  const [t] = useTranslation("investigation");

  return (
    <Stack padding={justView ? 0 : 2} spacing={2}>

      {
        evaluations.policies.list.length > 0 &&
        <SingleEvaluation
          evaluation={evaluations.policies}
          justView={justView}
          itemTitle={t("evaluation.policies_item_title")}
          color="#55E5B8"
          itemIcon="bold_security_danger"
        />
      }
      
      {
        evaluations.measures.list.length > 0 &&
        <SingleEvaluation
          evaluation={evaluations.measures}
          justView={justView}
          itemTitle={t("evaluation.measures_item_title")}
          color="#7BBDFF"
          itemIcon="bold_additem"
        />
      }

      {
        evaluations.actions.list.length > 0 &&
        <SingleEvaluation
          evaluation={evaluations.actions}
          justView={justView}
          itemTitle={t("evaluation.actions_item_title")}
          color="#F4996C"
          itemIcon="bold_security_danger"
        />
      }

      {
        causes.length > 0 &&
        causes.map((cause, idx) => (
          <SingleCause
            key={idx}
            cause={cause}
          />
        ))
      }

    </Stack>
  )
}